import { AgTechButtonProps, AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons";
import { useBidderDataRemoveBidderAction } from "@sales/data/bidders/BidderDataActions";

export type BidderRemovalButtonProps = AgTechButtonProps & {
    bidderId: number,
    bidderNumber?: string
}

export const BidderRemovalButton = (props: BidderRemovalButtonProps) => {
    let removeBidderAction = useBidderDataRemoveBidderAction();

    let buttonProps: AgTechButtonProps = {
        text: 'Remove Bidder',
        icon: 'fas fa-times',
        action: async e => {
            await e.actions.executeDataActionInModal(removeBidderAction, {
                originalEntity: { bidderId: props.bidderId, bidderNumber: props.bidderNumber },
                submittedEntity: { bidderId: props.bidderId, bidderNumber: props.bidderNumber }
            });
        },
        ...props
    };

    return <AgTechButton {...buttonProps} />
}